import { useEffect, useRef, useState } from 'react';

export const useComputeActiveDistance = ({
	index,
	scrollplay,
	inView,
	mobileRow,
	onChange,
}: {
	index: number;
	scrollplay: boolean;
	inView: boolean;
	mobileRow: number;
	onChange: (active: boolean) => void;
}) => {
	const [active, setActive] = useState(false);

	const ref = useRef<HTMLAnchorElement>(null);
	const offset = useRef(0);

	useEffect(() => {
		if (!inView || !ref.current) {
			return;
		}
		if (!scrollplay) {
			if (active) {
				setActive(false);
				onChange(false);
			}
			return;
		}

		const target = ref.current;
		if (!offset.current) {
			offset.current = target.getBoundingClientRect().top;
		}

		const update = () => {
			const { top } = target.getBoundingClientRect();
			const { height } = (
				target.previousElementSibling || target
			).getBoundingClientRect();
			const n = mobileRow;
			const k = Math.abs((index % n) - n);
			const d = index < n ? offset.current / n : (height + 24) / n; // 24 --gap-x6

			if (index === 0 && top >= offset.current) {
				if (!active) {
					setActive(true);
					onChange(true);
				}
			} else if (top > (k - 1) * d && top < k * d) {
				if (!active) {
					setActive(true);
					onChange(true);
				}
			} else {
				if (active) {
					setActive(false);
					onChange(false);
				}
			}
		};

		let rafId: number;

		const handleScroll = () => {
			cancelAnimationFrame(rafId);
			rafId = requestAnimationFrame(update);
		};

		window.addEventListener('scroll', handleScroll, { passive: true });

		return () => {
			window.removeEventListener('scroll', handleScroll);
			cancelAnimationFrame(rafId);
		};
	}, [index, mobileRow, active, inView, scrollplay, onChange]);

	return {
		ref,
	};
};
